import React from 'react';
import axios from '../axios';
import ModalContentBaseXl from '../redux/components/modal/modal_content_base_xl';

const SectionCircle = ({
  event,
  setEvent,
  usersCircles,
  setUsersCircles,
  circleError,
}) => {
  const [newCircle, setNewCircle] = React.useState([]);
  const [selected, setSelected] = React.useState(event.circle_id);
  const modalRef = React.useRef(null);

  const closeModal = React.useCallback(() => {
    modalRef.current.closeModal();
  });

  const createNewCircle = React.useCallback(() => {
    const circleName = JSON.stringify({
      circle_name: newCircle.name,
    });
    axios
      .post(`/api/event_edit/${event.id}/create_new_circle`, circleName)
      .then((response) => {
        setUsersCircles((prev) => [...prev, response.data]);
        setSelected((prevSelected) =>
          prevSelected === response.data.id ? prevSelected : response.data.id
        );
        closeModal();
      });
  }, [newCircle]);

  const updateEventsCircle = React.useCallback(
    (e) => {
      const circleId = e;
      const newEvent = {
        ...event,
        circle_id: circleId,
      };
      setEvent(newEvent);
      axios.post(
        `/api/event_edit/${event.id}/update_events_circle/${e}`,
        newEvent
      );
      setSelected((prevSelected) =>
        prevSelected === circleId ? prevSelected : circleId
      );
    },
    [event]
  );

  return (
    <section id="event_details">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-5 d-inline-block">
          主催サークル
        </p>
      </div>
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6">
          {circleError && (
            <p className="text-danger text-fz-small mt-0 mb-0">{circleError}</p>
          )}
          <div className="card-body p-0">
            <ul
              className="row flex-nowrap overflow-auto px-2 pt-3"
              style={{ listStyle: 'none' }}
            >
              {usersCircles && usersCircles.length < 10 && (
                <ModalContentBaseXl
                  ref={modalRef}
                  previewContent={
                    <li className="w-100">
                      <label className="circle-container">
                        <img
                          src="/images/ja2/img_noimage.gif"
                          className="circle-image"
                          alt="no-image"
                        ></img>
                        <div className="circle-overlay"></div>
                        <div className="circle-content">
                          <div className="circle-name-container">
                            <span
                              className="circle-name line-2 align-items-end"
                              style={{ position: 'absolute', bottom: '6%' }}
                            >
                              新規サークルで作成
                              <span>
                                <img
                                  src="/assets2019/add_circle_icon_ver_red.svg"
                                  alt=""
                                  className="pr-1"
                                ></img>
                              </span>
                            </span>
                          </div>
                        </div>
                      </label>
                    </li>
                  }
                  modalContent={
                    <div className="container col-md-8 col-lg-6 mt-5">
                      <p className="pt-2 form-label text-fz-20px text-fw-bold text-black-50 text-center">
                        新規サークル作成
                      </p>
                      <div className="mb-4">
                        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">
                          サークル名
                        </p>
                        <textarea
                          id="body"
                          className="form-control form-control-lg"
                          onChange={(e) => {
                            setNewCircle({
                              ...newCircle,
                              name: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div
                        className="w-100"
                        style={{ paddingRight: '10px', paddingLeft: '10px' }}
                      >
                        <button
                          type="button"
                          className="mx-1 a-button a-button__top a-button--orange w-100 mb-3"
                          value="semi_official"
                          onClick={createNewCircle}
                        >
                          新規サークル作成
                        </button>
                      </div>
                      <p className="text-center form-label text-fz-10px text-black-50">
                        サークル設定の変更はマイページから行えます。
                      </p>
                    </div>
                  }
                />
              )}
              {usersCircles.map((circle) => (
                <li key={circle.id} className="">
                  <label
                    key={circle.id}
                    className="circle-container"
                    style={{
                      border:
                        selected === circle.id ? '5px solid #FF6467' : 'none',
                    }}
                  >
                    <img
                      src={`${circle.main_image_thumb}`}
                      className="circle-image"
                      alt="サークル画像"
                    ></img>
                    <div className="circle-overlay"></div>
                    <div className="circle-content">
                      <div className="circle-name-container">
                        <span
                          className="circle-name line-2"
                          style={{ position: 'absolute', bottom: '6%' }}
                        >
                          {circle.name}
                        </span>
                        <input
                          type="checkbox"
                          style={{ display: 'none' }}
                          value={circle.id}
                          checked={selected == circle.id}
                          onChange={(e) =>
                            updateEventsCircle(Number(e.target.value))
                          }
                        />
                      </div>
                    </div>
                  </label>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionCircle;
